import { WebLayout } from 'components/Layout';

import { Hero } from '../components/Hero';
import { TrustBar } from '../components/TrustBar';
import { Shop } from '../components/Shop';
import { HowItWorks } from '../components/HowItWorks';
import { CtaBanner } from '../components/CtaBanner';

export function Landing() {
  return (
    <WebLayout>
      <Hero />
      <TrustBar />
      <Shop />
      <HowItWorks />
      <CtaBanner />
    </WebLayout>
  );
}
